var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-ctn"},[_c('img',{staticClass:"contact-qr",attrs:{"src":require("@/assets/images/codigo-qr-contato-onesti.png"),"alt":((_vm.$t('alt.qr')) + " ")}})])}
var staticRenderFns = []

export { render, staticRenderFns }